<template>
<b-dropdown v-if="!willysm.enabled" right no-caret>

  <template v-if="feeling == 'sunny'" class="dropdown-toggle count-info" slot="button-content">
    <img alt="image" class="img-circle" src="static/img/assets/status_01.png">
  </template>
  <template v-else-if="feeling == 'rainy'" class="dropdown-toggle count-info" slot="button-content">
    <img alt="image" class="img-circle" src="static/img/assets/status_03.png">
  </template>
  <template v-else class="dropdown-toggle count-info" slot="button-content">
    <img alt="image" class="img-circle" src="static/img/assets/status_02.png">
  </template>

  <!-- <ul class="dropdown-menu dropdown-alerts status-alerts"> -->
  <template>
      <b-dropdown-item @click="change('sunny')">
          <span class="info-feelingimg"><img alt="image" src="static/img/assets/status_01.png"></span>
      </b-dropdown-item>
      <b-dropdown-item @click="change('cloudy')">
          <span class="info-feelingimg"><img alt="image" src="static/img/assets/status_02.png"></span>
      </b-dropdown-item>
      <b-dropdown-item @click="change('rainy')">
          <span class="info-feelingimg"><img alt="image" src="static/img/assets/status_03.png"></span>
      </b-dropdown-item>
  </template>

</b-dropdown>
<div v-else class="willysm" >
  <img alt="image" class="willysmImage" v-bind:src="willysmImage" v-on:click.self="willysmLink()">
</div>

</template>

<script>
import { willysm } from '@/main.js'
export default {
  name: 'ProfileDropDown',
  props: {
    // tag: {
    //   type: String
    // },
    editting: {
      type: Boolean
    },
    feeling: {
      type: String
    }
  },
  data () {
    return {
      tag: this.tag,
      willysm: willysm,
      willysmImage: 'static/img/extApps/willysm/' + willysm.image
    }
  },
  methods: {
    change: function (value) {
      // alert('change=' + value)
      this.$emit('set-feeling', value)
    },
    willysmLink: function () {
      window.location.href = willysm.link
    }
  }
}
</script>
<style scoped>
 .willysmImage {
   display: unset;
   width: 100%;
   min-width: 100%;
   position: relative;
   top: 5px;
   right: 51px;
   cursor: pointer;
   cursor: hand;
 }
.willysm {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/User/ProfileDropDown.vue